module.exports = __webpack_public_path__ + "media/images/awards-6-cd0cc80835775d54e226ef0ab8320143.jpg";